export default __webpack_public_path__ + "static/media/fail.9034111b.png";